import PropTypes from 'prop-types';

const If = ({ condition, render, children }) => {
  if (condition) {
    return render ? render() : children;
  }
  return null;
};
export default If;

If.propTypes = {
  condition: PropTypes.bool,
  render: PropTypes.func || PropTypes.element,
  children: PropTypes.element || PropTypes.func,
};
